export default __webpack_public_path__ + "static/media/car-profile.4f2bfc05.png";